/**
 * Frontend Cache Manager
 *
 * Simple event-based cache invalidation system for frontend components.
 * When admin updates data, they can trigger a cache refresh event.
 */

// Cache refresh listeners
const listeners = {
  tours: [],
  gallery: [],
  reviews: [],
  addons: []
};

/**
 * Subscribe to cache refresh events
 * @param {string} dataType - Type of data (tours, gallery, reviews, addons)
 * @param {Function} callback - Function to call when cache should be refreshed
 * @returns {Function} Unsubscribe function
 */
export function subscribeToCacheRefresh(dataType, callback) {
  if (!listeners[dataType]) {
    listeners[dataType] = [];
  }

  listeners[dataType].push(callback);

  // Return unsubscribe function
  return () => {
    const index = listeners[dataType].indexOf(callback);
    if (index > -1) {
      listeners[dataType].splice(index, 1);
    }
  };
}

/**
 * Trigger cache refresh for specific data type
 * @param {string} dataType - Type of data that was updated
 */
export function triggerCacheRefresh(dataType) {
  console.log(`[CACHE MANAGER] Triggering refresh for: ${dataType}`);

  if (listeners[dataType]) {
    listeners[dataType].forEach(callback => {
      try {
        callback();
      } catch (error) {
        console.error(`[CACHE MANAGER] Error in refresh callback:`, error);
      }
    });
  }
}

/**
 * Trigger cache refresh for multiple data types
 * @param {string[]} dataTypes - Array of data types to refresh
 */
export function triggerMultipleCacheRefresh(dataTypes) {
  dataTypes.forEach(type => triggerCacheRefresh(type));
}

// Export as default as well for easier imports
export default {
  subscribeToCacheRefresh,
  triggerCacheRefresh,
  triggerMultipleCacheRefresh
};
